module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/qabdo6-242586159bbf04a3139b32092ce529f8.jpg";